import { PREFIX } from "./base";

export const BOX_PLOT_OUTLIER_VALUE_FIELD = `${PREFIX}_BOX_PLOT_OUTLIER_VALUE`;

export var BOX_PLOT_TOOLTIP_KEYS;

!function(BOX_PLOT_TOOLTIP_KEYS) {
    BOX_PLOT_TOOLTIP_KEYS.OUTLIER = "outlier", BOX_PLOT_TOOLTIP_KEYS.MAX = "max", BOX_PLOT_TOOLTIP_KEYS.MIN = "min", 
    BOX_PLOT_TOOLTIP_KEYS.MEDIAN = "median", BOX_PLOT_TOOLTIP_KEYS.Q1 = "q1", BOX_PLOT_TOOLTIP_KEYS.Q3 = "q3", 
    BOX_PLOT_TOOLTIP_KEYS.SERIES_FIELD = "seriesField";
}(BOX_PLOT_TOOLTIP_KEYS || (BOX_PLOT_TOOLTIP_KEYS = {}));
//# sourceMappingURL=box-plot.js.map